<script>
  import {External, M} from "../external";
  import {onMount} from "svelte";

  export let change, selected;

  const shortMonths = [M.JAN, M.FEB, M.MAR, M.APR, M.MAY_SHORT, M.JUN, M.JUL, M.AUG, M.SEP, M.OCT, M.NOV, M.DEC];

  let items = [
    {
      label: M.TODAY,
      id: "today"
    },
    {
      label: M.YESTERDAY,
      id: "yesterday"
    },
    {
      label: M.LSAT_7_DAYS,
      id: "7-days"
    },
    {
      label: M.LSAT_14_DAYS,
      id: "14-days"
    },
    {
      label: M.THIS_MONTH,
      id: "month"
    },
    {
      label: M.LAST_MONTH,
      id: "last-month"
    },
    {
      label: M.ALL_TIME_FILTER,
      id: "all"
    },
    {
      label: M.CUSTOM,
      id: "custom"
    }
  ];

  export let showPeriods = ['today', 'yesterday', '7-days', '14-days', 'month', 'all', 'custom'];

  onMount(() => {
    items = items.filter(item => showPeriods.includes(item.id));
  });

  let onItemSelected = (item) => {
    let todayStart = new Date();
    todayStart.setHours(0, 0, 0, 0);
    let todayEnd = new Date();
    todayEnd.setHours(23, 59, 59, 999);

    selected.label = item.label;
    selected.id = item.id;
    switch (item.id) {
      case "today":
        selected.from = todayStart;
        selected.to = todayEnd;
        break;
      case "yesterday":
        todayStart.setDate(todayStart.getDate() - 1);
        todayEnd.setDate(todayEnd.getDate() - 1);
        selected.from = todayStart;
        selected.to = todayEnd;
        break;
      case "7-days":
        todayStart.setDate(todayStart.getDate() - 6);
        selected.from = todayStart;
        selected.to = todayEnd;
        break;
      case "14-days":
        todayStart.setDate(todayStart.getDate() - 13);
        selected.from = todayStart;
        selected.to = todayEnd;
        break;
      case "month":
        todayStart.setDate(1);
        selected.from = todayStart;
        selected.to = todayEnd;
        break;
      case "last-month":
        var from = new Date();
        from.setDate(0); // going back to the end of the previous month
        from.setDate(1); // then to the start of the previous month
        from.setHours(0, 0, 0, 0);
        var to = new Date();
        to.setDate(0);
        to.setHours(23, 59, 59, 999); // then to the end of the previous month

        selected.from = from;
        selected.to = to;
        break;
      case "all":
        selected.from = selected.to = null;
        break;
      case "custom":
        return;
    }
    change(selected);
  };

  let applyDateRangeFilter = () => {
    selected.from.setHours(0, 0, 0, 0);
    selected.to.setHours(23, 59, 59, 999);
    selected.label = selected.from.getDate() + " " + shortMonths[selected.from.getMonth()] + " - " + selected.to.getDate() + " " + shortMonths[selected.to.getMonth()];
    change(selected);
  };

  let executeDate = (node) => {
    let property = node.dataset.property;
    let date;
    if (property === "from") {
      if (!selected.from) {
        selected.from = new Date();
      }

      date = selected.from;
    } else {
      if (!selected.to) {
        selected.to = new Date();
      }

      date = selected.to;
    }
    const target = External.$(node);
    target
      .datepicker({
        maxDate: new Date(),
        dateFormat: External.WebsiteSettings.getDateFormat() === "us" ? "mm/dd/yy" : "dd/mm/yy",
        currentText: M.TIME_NOW,
        closeText: M.CLOSE,
        timeText: M.TIME,
        hourText: M.TIME_HOUR,
        minuteText: M.TIME_MINUTE,
        monthNamesShort: shortMonths,
        monthNames: [M.JANUARY, M.FEBRUARY, M.MARCH, M.APRIL, M.MAY, M.JUNE, M.JULY, M.AUGUST, M.SEPTEMBER, M.OCTOBER, M.NOVEMBER, M.DECEMBER],
        onSelect: function (dateText) {
          let date = External.$(this).datepicker("getDate");
          selected[property] = date;
        }
      })
      .datepicker("setDate", date);

    return {
      destroy() {
        target.datepicker("destroy");
      }
    };
  };
</script>

<ul>
  {#each items as item}
    <li class="system-bg-color-hover system-bg-color-active" class:active={selected.id === item.id}>
      <a on:click={() => onItemSelected(item)}>{item.label}</a>
      {#if item.id === "custom"}
        <div class="popup-range-picker col20 f-left flex flex-col align-center" class:none={selected.id !== item.id}>
          <div class="col20 f-left flex flex-row align-center justify-center">
            <input type="text" class="flex-none" use:executeDate data-property="from" />
            <span class="flex-none">-</span>
            <input type="text" class="flex-none" use:executeDate data-property="to" />
          </div>
          <a class="small-button blue circle-effect mb-5 flex-none" on:click={applyDateRangeFilter}>{M.APPLY}</a>
        </div>
      {/if}
    </li>
  {/each}
</ul>

<style>
  .popup-range-picker {
    background: #ffffff;
  }
  .popup-range-picker input {
    padding: 8px;
    width: 80px;
    text-indent: 0px;
    margin: 8px;
  }

  .popup-range-picker a.small-button {
    width: auto;
    margin-left: 0;
  }
</style>
